import { Api } from "../api/Api";
import { paramIds } from "../api/ApiUtil";
import { AerialImage } from "../api/Application";
import { LoaderFunctionArgs } from "react-router-dom";

export interface ImageAlignLoaderData {
    imageA: AerialImage;
    imageB: AerialImage;
}

export async function imageAlignLoader( { params }: LoaderFunctionArgs ): Promise<ImageAlignLoaderData> {
    const { runId } = paramIds( params );
    const [run] = await Promise.all( [
        Api.abandonedVehicleRunGet( runId ),        
    ] );

    if( !run.isOk ) throw new Error( "Failed to fetch run. Make sure you are logged in." );

    return {
        imageA: run.value.before,
        imageB: run.value.after,
    };
}

